import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core";

import HomeContainer from "./HomeContainer";
import AboutContainer from "./AboutContainer";
import ServicesContainer from "./ServicesContainer";
import ContactContainer from "./ContactContainer";
import NavBar from "./helperComponents/NavBar";
import Footer from "./helperComponents/Footer";
import ConsultationServices from "./ConsultationServicesContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    background: "#f5dd3a",
  },
  rest: {
    position: "absolute",
    top: "100vh",
    width: "100vw",
  },
}));

const MainContainer = () => {
  const classes = useStyles();

  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const sevicesRef = useRef(null);
  const consultationServicesRef = useRef(null);
  const contactRef = useRef(null);

  const refProps = {
    home: homeRef,
    about: aboutRef,
    services: sevicesRef,
    consultationServices: consultationServicesRef,
    contact: contactRef,
  };

  /* 
   TODO:
    X Change Color Palette
    X Repair Email service
    X White space after HomeContainer in Mobile
    X Add LIC Logo
    X Change Contact Form
    X Fill Services
    X Add Consultation Services
    X Fill About
    * Change Picture
  */

  const [refInView, setRefInView] = useState(null);

  const scrollTo = (ref) => {
    if (ref) ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className={classes.root}>
      <NavBar refProps={refProps} scrollTo={scrollTo} refInView={refInView} />
      <HomeContainer
        refProp={homeRef}
        refProps={refProps}
        scrollTo={scrollTo}
        setRefInView={setRefInView}
      />
      <div className={classes.rest}>
        <AboutContainer refProp={aboutRef} setRefInView={setRefInView} />
        <ServicesContainer refProp={sevicesRef} setRefInView={setRefInView} />
        <ConsultationServices
          refProp={consultationServicesRef}
          setRefInView={setRefInView}
        />
        <ContactContainer refProp={contactRef} setRefInView={setRefInView} />
        <Footer />
      </div>
    </div>
  );
};

export default MainContainer;
